// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"574":"78c37e78","6361":"566804dc"}[chunkId] + ".chunk.css";
};